import { render, staticRenderFns } from "./PriceComparisonH1.vue?vue&type=template&id=3c71c1c0&scoped=true"
import script from "./PriceComparisonH1.vue?vue&type=script&lang=ts"
export * from "./PriceComparisonH1.vue?vue&type=script&lang=ts"
import style0 from "./PriceComparisonH1.vue?vue&type=style&index=0&id=3c71c1c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71c1c0",
  null
  
)

export default component.exports